export const sslCheck = (location = window.location) => location.protocol === "https:"